import Header from './components/Header';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <CarouselSection />
        <AboutSection />
        <UpdatesSection />
        <AppSection />
        <CardsSection />
        <CommentsSection />
        <RankingSection />
        <MediaSection />
        <FaqSection />
        <FeaturesSection />
        <ContactSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}